import { uniqueId } from 'lodash';

import { ApiModel } from 'lib/interfaces/api';
import { UiStepType } from 'lib/interfaces/StepsConfig';
import {
  Inquiry,
  InquiryAttributes,
  InquiryRelationships,
  InquiryStatus,
} from 'verify/models/inquiry';

export const generateInquiryId = () => uniqueId('inq_');

export function createMockInquiry(
  attributes?: Partial<InquiryAttributes>,
  relationships?: Partial<InquiryRelationships>,
  id?: string,
): Inquiry {
  return {
    attributes: {
      status: InquiryStatus.Pending,
      'next-step': {
        name: UiStepType.Completed,
        type: UiStepType.Completed,
      },
      'created-at': '',
      'selected-country-code': 'US',
      logo: null,
      ...attributes,
    },
    id: id || generateInquiryId(),
    relationships: {
      account: {
        data: {
          id: 'account_id',
          type: ApiModel.Account,
        },
      },
      template: {
        data: {
          id: 'app_id',
          type: ApiModel.Template,
        },
      },
      'inquiry-template-version': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      theme: {
        data: {
          id: 'theme_id',
          type: ApiModel.Theme,
        },
      },
      environment: {
        data: {
          id: 'environment_id',
          type: ApiModel.EnvironmentProduction,
        },
      },
      verifications: {
        data: [],
      },
      organization: {
        data: {
          id: 'organization_id',
          type: ApiModel.Organization,
        },
      },
      ...relationships,
    },
    type: ApiModel.Inquiry,
  };
}
